/**
 * @file
 * CTA Dropdown component behaviors.
 *
 * @param {object} Drupal - The Drupal object.
 */

(function (Drupal) {
  'use strict';

  Drupal.behaviors.ctaDropdown = {
    attach: function (context, settings) {

      /* eslint-disable max-nested-callbacks */
      once('js-cta-dropdown', '[data-component-id="tnvacation:cta-dropdown"]', context).forEach(function (component) {
        const button = component.querySelector('.cta-dropdown__button');
        const links = component.querySelectorAll('.cta-dropdown__item');

        // Toggle the dropdown open/closed
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded');
          button.setAttribute('aria-expanded', expanded === 'true' ? 'false' : 'true');
        });

        // Close the dropdown on link click
        links.forEach((link) => {
          link.addEventListener('click', () => {
            button.setAttribute('aria-expanded', 'false');
          });
        });
      });
    }
  };
})(Drupal);
